import Reveal from "@/components/Reveal";
import { Star, BadgeCheck } from "lucide-react";

const reviews = [
  {
    id: "khadija",
    name: "خديجة",
    city: "الدار البيضاء",
    stars: 5,
    text: "من بعد جوج سيمانات ديال الاستعمال اليومي، لاحظت فرق واضح فالمظهر ديال أظافري، ولات كتبان صحية أكثر، وكنلاحظ حتى تحسّن فالرائحة ديالها بسرعة.",
  },
  {
    id: "youssef",
    name: "يوسف",
    city: "الرباط",
    stars: 5,
    text: "كنت متردد فالأول، ولكن المنتج فعلاً طبيعي وساهل فالاستعمال، والتوصيل وصلني فوج أيام، وحتى الدفع عند الاستلام مريح بزاف.",
  },
  {
    id: "salma",
    name: "سلمى",
    city: "مراكش",
    stars: 5,
    text: "كنستعملو صباح وليل، وبصراحة أظافري ولات كتبان نقية ومرتّبة أكثر، والعلبة كافية لمدة طويلة.",
  },
  {
    id: "amine",
    name: "أمين",
    city: "طنجة",
    stars: 4,
    text: "خديتو للأظافر ديال رجلي، والنتيجة زوينة مع المواظبة اليومية، وخدمة الزبناء جاوباتني فالواتساب بسرعة.",
  },
];

function Stars({ n }) {
  return (
    <div className="flex gap-0.5" dir="ltr" aria-label={`${n} من 5 نجوم`}>
      {[1, 2, 3, 4, 5].map((i) => (
        <Star
          key={i}
          className={`h-4 w-4 ${i <= n ? "fill-[#D4AF37] text-[#D4AF37]" : "text-[#D4AF37]/30"}`}
        />
      ))}
    </div>
  );
}

export default function Reviews() {
  return (
    <section id="reviews" className="border-y border-[#2E9E6B]/10 bg-[#F4F1EA]/60 py-20 lg:py-28">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <Reveal>
          <p className="text-sm font-bold tracking-[0.3em] text-[#2E9E6B]">آراء زبنائنا</p>
          <h2 className="font-display mt-3 max-w-xl text-2xl font-black leading-snug text-[#0F1E19] sm:text-3xl lg:text-4xl">
            زبناء من كل المدن المغربية جرّبوا يوكيور
          </h2>
        </Reveal>

        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {reviews.map((r, i) => (
            <Reveal key={r.id} delay={i * 0.08}>
              <figure
                className="flex h-full flex-col rounded-3xl border border-[#2E9E6B]/15 bg-white p-6 transition-all duration-500 hover:-translate-y-1.5 hover:border-[#2E9E6B]/40 hover:shadow-xl hover:shadow-emerald-900/10"
                data-testid={`review-card-${r.id}`}
              >
                <Stars n={r.stars} />
                <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-[#162822]">
                  “{r.text}”
                </blockquote>
                <figcaption className="mt-5 border-t border-[#2E9E6B]/10 pt-4">
                  <p className="text-sm font-black text-[#0F1E19]">
                    {r.name} <span className="font-medium text-[#566B63]">· {r.city}</span>
                  </p>
                  <p className="mt-1 flex items-center gap-1 text-[11px] font-bold text-[#2E9E6B]">
                    <BadgeCheck className="h-3.5 w-3.5" />
                    شراء موثّق
                  </p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
